import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Typography,
  IconButton,
  useMediaQuery,
  Badge
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import RefreshIcon from '@mui/icons-material/Refresh';
import SwitchAccountIcon from '@mui/icons-material/SwitchAccount';
import { useTheme } from '@mui/material/styles';
import { useDispatch, useSelector } from 'react-redux';
import ShiftTimerComponent from '../../../component/Single Components/ShiftTimerComponent';
import { selfDialogScreenSelected, setScreenLoginType } from '../../Slices/selfOrderMainSlice';
import { getShiftStatusAPICAll } from '../../../API/Settings/Shift/viewShiftAPI';
import { getCurrentTime, today } from '../../../Js/Date';
import DvrIcon from '@mui/icons-material/Dvr';
import { onGoingOrdersForSelf } from '../../API/selfOrderAPIS';
import SelfOngoingOrders from '../Order/SelfOngoingOrders';
import { errorSnackMsg } from '../../../component/Custom Hooks/SnackkBarUtilities';
import ShiftControls from './ShiftControls';
import SelfReceiptSettings from './SelfReceiptSettings';
const MenuDialog = ({ open, handleClose }) => {
  const theme = useTheme();
  const dispatch=useDispatch();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const shiftStatus = useSelector((state) => state.shiftStatusSlice.value);
  const { branchPk,data} = useSelector((state) => state.loginResponseSlice.value);
  const {ongoingOrders}=useSelector((state)=>state.selfOrderMainSlice)

  const storedBranchId = localStorage.getItem('branchId');
  const effectiveBranchId = branchPk || storedBranchId;
  const effectiveWaiterId = data?._id;
  const selfUser = localStorage.getItem('selfUser');
  const loginChangeClick=()=>{
    localStorage.setItem("selfUser","selfUser")
    dispatch(setScreenLoginType("selfUser"))
    dispatch(selfDialogScreenSelected(null))
  }

  const logoutClick=()=>{
    const printValue = localStorage.getItem("PrinterSettings");
    localStorage.clear();
    if (printValue !== null) {
      localStorage.setItem("PrinterSettings", printValue);
    }
    window.location.replace("/");
  }
  const ordersClick=()=>{
    if (!effectiveBranchId) {
      errorSnackMsg('Branch not found. Please login again.');
      return;
    }

    dispatch(selfDialogScreenSelected("ordersDialog"));
    onGoingOrdersForSelf({
      type: 1,
      branchId: effectiveBranchId,
      ...(selfUser === 'STAFF' && effectiveWaiterId ? { waiterId: effectiveWaiterId } : {})
    });
  }
  const getShiftStatus=()=>{
    getShiftStatusAPICAll({
      branchId: effectiveBranchId,
      curTime: `${today} ${getCurrentTime()}`,
    });
  }
  
  useEffect(()=>{
    if(open){
      getShiftStatus()
      if (effectiveBranchId) {
        onGoingOrdersForSelf({
          type: 1,
          branchId: effectiveBranchId,
          ...(selfUser === 'STAFF' && effectiveWaiterId ? { waiterId: effectiveWaiterId } : {})
        })
      }
    } 
  },[open, effectiveBranchId, effectiveWaiterId])
  return (
    <Dialog 
      open={open} 
      onClose={handleClose} 
      maxWidth="xs" 
      fullWidth
    >
      <DialogTitle>
        <Grid container justifyContent="space-between" alignItems="center">
          <Typography variant="h6">
          SHIFT {shiftStatus?shiftStatus?.shiftId:"Not found"}
          </Typography>
          {
            !shiftStatus &&
          <IconButton onClick={getShiftStatus}>
            <RefreshIcon color='error'/>
          </IconButton>}
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>

      <DialogContent>
        <Grid container direction="column" justifyContent="center" alignItems="center">
          <Typography variant="h4" margin={0}>
            <ShiftTimerComponent/>
          </Typography>
          {selfUser === 'STAFF' && (
            <Grid item xs={12} container justifyContent="center" sx={{ mt: 2 }}>
              <ShiftControls />
            </Grid>
          )}
          <Grid item xs={12} sx={{ width: '100%' }}>
            <SelfReceiptSettings />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Grid container justifyContent="center" alignItems="center" spacing={2}>
          <Grid item xs={4} container justifyContent={isMobile?"end":"center"}>
            {isMobile ? (
              <IconButton onClick={loginChangeClick} color="primary" sx={{backgroundColor:"#e7e7e7"}}>
                <SwitchAccountIcon />
              </IconButton>
            ) : (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={loginChangeClick}
              >
                 Login Type
              </Button>
            )}
          </Grid>

          <Grid item xs={4} container justifyContent={"center"}>
            {isMobile ? (
              <Badge
                badgeContent={ongoingOrders?.length > 0 ? ongoingOrders.length : null}
                color="error"
                overlap="circular"
              >
                <IconButton
                  color="warning"
                  sx={{ backgroundColor: "#e7e7e7" }}
                  onClick={ordersClick}
                >
                  <DvrIcon />
                </IconButton>
              </Badge>
            ) : (
              <Badge
                badgeContent={ongoingOrders?.length > 0 ? ongoingOrders.length : null}
                color="error"
              >
                <Button
                  fullWidth
                  variant="contained"
                  color="warning"
                  onClick={ordersClick}
                >
                  Orders
                </Button>
              </Badge>
            )}
          </Grid>

          <Grid item xs={4} container justifyContent={isMobile?"start":"center"}>
            {isMobile ? (
              <IconButton 
              onClick={logoutClick}
              color="error" sx={{backgroundColor:"#e7e7e7"}}>
                <LogoutIcon />
              </IconButton>
            ) : (
              <Button
                fullWidth
                variant="contained"
                color="error"
                onClick={logoutClick}
              >
                Logout
              </Button>
            )}
          </Grid>
        </Grid>
      </DialogActions>

      <SelfOngoingOrders/>
    </Dialog>
  );
};

export default MenuDialog;
